export default __webpack_public_path__ + "assets/05_3DMeaure.png";